import { Flex, Stack, TFText } from '@tf/ui';
import type React from 'react';

interface Props {
	title: string;
	subTitle?: string;
	onClick: () => void;
	icon?: React.ReactElement;
	children?: React.ReactNode;
	error?: string;
}

export const ActionCard: React.FC<Props> = ({ onClick, icon, title, children, error }) => {
	return (
		<Flex
			onClick={onClick}
			align="center"
			sx={{
				cursor: 'pointer',
				width: '100%',
				padding: '12px',
				borderRadius: '4px',
				border: `1px solid ${error ? '#DC2626' : '#E5E7EB'}`,
				transition: 'background-color 0.2s',
				'&:hover': {
					backgroundColor: '#F8FAFC',
				},
			}}
		>
			<Flex w="100%" align="center">
				{icon}
				<Stack gap="4px">
					<TFText fw="500" fz="16px" lh="20px" maw={460}>
						{title}
					</TFText>
					<TFText c="#DC2626" fz="14px" lh="18px" maw={460}>
						{error}
					</TFText>
				</Stack>
				{children}
			</Flex>
		</Flex>
	);
};
